import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'

export const Panel = styled.div`
  width: 750px;
  padding: 40px 50px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  background: #fdf4e1;

  ${({ theme }) => theme.mediaWidth.upToLarge`
    padding: 40px 0px;
  `};

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: auto;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding: 18px 0px;
  `};
`

export const Title = styled.div`
  margin: 0px auto 44px;
  font-size: 22px;
  font-family: ${props => props.theme.typography.fontFamily.primary};
  text-align: center;

  ${({ theme }) => theme.mediaWidth.upToLarge`
    display: none;
  `};
`

export const Coins = styled.div`
  min-height: 190px;
  margin-bottom: 40px;
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(auto-fill, 50px);
  gap: 20px 25px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-bottom: 0px;
    grid-template-columns: auto;
    grid-auto-flow: row;
    gap: 8px;
    order: 1;
  `};
`

export const Coin = styled(Link)`
  display: flex;
  align-items: center;
  height: 50px;
  border: 3px solid #000000;
  border-radius: 25px;
  background: #ffffff;
  transition: 0.3s;
  font-size: 15px;
  color: black;
  text-decoration: none;

  &:hover {
    border-color: #f3ba2f;
    transition: 0.1s;
  }

  > * {
    position: relative;
  }

  & > *:not(:last-child):after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    right: 0px;
    transform: translateY(-50%);
    height: 24px;
    width: 1px;
    background: #999999;
  }

  ${({ theme }) => theme.mediaWidth.upToMedium`
    border-width: 1px;
    border-radius: 10px;
  `};
`

export const CoinName = styled.div`
  flex-grow: 1;
`

export const CoinIcon = styled.img`
  max-height: 34px;
  max-width: 34px;
  margin: 0px 7px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    max-height: 28px;
    max-width: 28px;
  `};
`

export const CoinParameter = styled.div`
  padding-left: 6px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  &[data-coin-parameter='APY'] {
    width: 35%;
  }
  &[data-coin-parameter='TVL'] {
    width: 29%;
  }
`

export const CoinParameterName = styled.span`
  font-size: 14px;
  color: #999999;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 13px;
    display: block;
  `};
`

export const Chains = styled.div`
  display: flex;
  justify-content: center;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-bottom: 18px;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-content: flex-start;
  `};
`

export const Chain = styled.button<{ active: boolean }>`
  display: flex;
  align-items: center;
  height: 38px;
  margin: 0 4px;
  padding: 5px 16px;
  border: none;
  border-radius: 25px;
  background: #ffffff;
  color: #564a27;
  font-size: 16px;
  transition: 0.3s;
  cursor: pointer;

  svg {
    margin-right: 10px;
  }

  svg * {
    fill: #564a27;
    transition: 0.2s;
  }

  &:hover {
    background: #f3ba2f4a;
    transition: 0.3s;
  }

  ${props =>
    props.active &&
    css`
      background: #f3ba2f;
      color: white;
      transition: 0.3s;

      &:hover {
        background: #f3ba2f;
      }

      svg * {
        fill: white;
        transition: 0.2s;
      }
    `}

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 38px;
    height: 38px;
    padding: 0px;
    justify-content: center;

    span {
      display: none;
    }

    svg {
      margin-right: 0px;
    }
  `};
`
